<div class="countdown-timer">
    <span class="timer-legend font-subtitle-regular">Reenviar código OTP en </span>
    <i class='bx bxs-hourglass-top bx-tada' style="color: grey;"></i>
    <span class="font-subtitle-regular" style="color: grey;">{{ display }}</span>
</div>